/** The accepted server cast owns this area's timing, geometry and one damage scan.
 * Keep this classification import-free: ability construction uses it before
 * content-backed combat tables have necessarily finished initializing. */
export function serverOwnsAreaDamage(abilityId: string | null | undefined): boolean {
  return abilityId === 'howl_of_terror';
}
